<template>
  <div class="navigator">
    <div class="navigator-list">
      <router-link
        v-for="item in navigator"
        :key="item.path"
        class="navigator-item"
        tag="a"
        exact
        :to="item.path"
      >{{ item.title }}</router-link>
    </div>
    <div class="search">
      <el-input v-model="keyword" placeholder="搜索项目" @keyup.enter.native="search">
        <img slot="suffix" class="icon-search" src="../assets/images/icon-search.png" @click="search">
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigatorBar',

  data() {
    return {
      navigator: [
        {
          path: '/index',
          title: '首页'
        },
        {
          path: '/bid/notice',
          title: '招标公告'
        },
        {
          path: '/bid/win',
          title: '中标公告'
        },
        {
          path: '/bid/preview',
          title: '招标预告'
        },
        {
          path: '/news',
          title: '最新资讯'
        },
        {
          path: '/download',
          title: '模板下载'
        }
      ],

      keyword: ''
    }
  },

  computed: {
    currentRoutePath() {
      return this.$route.path
    }
  },

  methods: {
    /*
     * 搜索
    */
    search(e) {
      if (!this.keyword) return

      this.$router.push({
        path: '/bid/search',
        query: {
          keyword: this.keyword
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.navigator {
  display: flex;
  align-items: center;
  .navigator-list {
    flex: 1;
    display: flex;
    font-size: 16px;
    .navigator-item {
      white-space: nowrap;
      cursor: pointer;
      &:nth-child(n + 2) {
        margin: 0 0 0 30px;
      }
    }
    .router-link-active {
      color: #417ef7;
    }
  }
  .search {
    margin: 0 0 0 36px;
    /deep/ .el-input {
      > input {
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        padding: 0 51px 0 20px;
      }
      .el-input__suffix {
        right: 17px;
        display: flex;
        align-items: center;
      }
      .icon-search {
        vertical-align: top;
      }
    }
  }
}
</style>
